import { MenuItem } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { SIZES } from "../utils/enums";

interface GenericSelectProps {
  disabled?: boolean;
  value: string;
  onChange: (e: SelectChangeEvent) => void;
  options: { label: string; value: string }[];
  className?: string;
}

const GenericSelect = ({
  disabled = false,
  value,
  onChange,
  options,
  className = "",
}: GenericSelectProps) => {
  return (
    <Select
      className={className}
      disabled={disabled}
      size={SIZES.sm}
      value={value}
      onChange={onChange}
      sx={{
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "var(--color-neutral-dark)",
        },
        fontSize: {
          md: "0.875rem",
          xl: "1rem",
        },
      }}
      MenuProps={{
        sx: {
          maxHeight: 400,
          fontSize: {
            md: "0.875rem",
            xl: "1rem",
          },
        },
      }}
    >
      {options.map((option, index) => (
        <MenuItem key={index} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default GenericSelect;
